import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { withoutPrePostFilterEmitterTypes } from 'utils/isPrePostFilterEmitterType'

export const getAvailableEmitterTypes = (
  properties: Record<number, TProperty> | undefined = fieldAssetStore.getState()?.properties,
) => {
  return [
    ...new Set<TEmitterType>(
      Object.values(properties ?? {}).flatMap((property) =>
        property.points
          ? Object.values(property.points).flatMap((pt) =>
              withoutPrePostFilterEmitterTypes(pt.configuration.irrigationEmitterTypesAvailable),
            )
          : [],
      ),
    ),
  ]
}
